<template>
    <div class="panel">
        <img :src="require('@/assets/images/panel_graphics/intro.png')" alt="">
    </div>
</template>

<script>
    export default {
        name: 'Intro_panel',
        bg_graphic: require('@/assets/images/panel_graphics/intro.png')
    }
</script>
<style lang="stylus">
.panel
    text-align: center
    border-radius: 11%
    height: 450px
    width: 450px
</style>
<style scoped lang="stylus">
.panel
    background: none !important
</style>